import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DropDownButtonDefinition } from 'src/app/shared/model/DropDownButtonDefinition';

@Component({
  selector: 'app-custom-drop-down-button-ctrl',
  templateUrl: './custom-drop-down-button.component.html',
  styleUrls: ['./custom-drop-down-button.component.scss']
})
export class CustomDropDownButtonComponent implements OnInit {

  constructor(
    private translateService: TranslateService
  ) { }

  @Input() buttonOptions: Array<DropDownButtonDefinition>;
  @Input() caption:string;
  @Output() itemClickedEvent = new EventEmitter<DropDownButtonDefinition>();
  
  ngOnInit(): void {
    this.buttonOptions?.forEach( x => x.text = this.translateService.instant(x.text));
  }

  itemClick($event: DropDownButtonDefinition){
    this.itemClickedEvent.emit($event);
  }

}
